import { Linkedin, Instagram, Twitter } from "lucide-react";
import { LandingLogo } from "./shared";

const COLUMNS = [
  {
    title: "Company",
    links: ["About", "Careers", "Contact"],
  },
  {
    title: "Platform",
    links: ["Platform", "Solutions"],
  },
  {
    title: "Resources",
    links: ["Resources", "Privacy Policy", "Terms of Service"],
  },
];

const HREF_MAP = {
  About: "#about",
  Platform: "#platform",
  Solutions: "#solutions",
  Resources: "#resources",
  Contact: "#contact",
  Careers: "#contact",
  "Privacy Policy": "#",
  "Terms of Service": "#",
};

const SOCIALS = [
  { icon: Linkedin, label: "LinkedIn", testId: "social-linkedin" },
  { icon: Instagram, label: "Instagram", testId: "social-instagram" },
  { icon: Twitter, label: "X (Twitter)", testId: "social-twitter" },
];

export default function Footer() {
  return (
    <footer data-testid="landing-footer" className="bg-[#0B1220] text-white">
      <div className="max-w-7xl mx-auto px-6 py-16 lg:py-20">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <LandingLogoLight />
            </div>
            <p className="text-sm text-slate-400 leading-relaxed mt-5 max-w-sm">
              The AI Copilot for Modern Orthodontic Practices. Helping orthodontists spend less time
              on administration and more time treating patients.
            </p>
            <div className="flex gap-3 mt-7">
              {SOCIALS.map((social) => (
                <a
                  key={social.label}
                  href="#"
                  aria-label={social.label}
                  data-testid={social.testId}
                  className="w-10 h-10 rounded-full border border-white/15 flex items-center justify-center text-slate-400 transition-[color,border-color,background-color,transform] duration-300 hover:text-white hover:border-white/40 hover:bg-white/5 hover:-translate-y-0.5"
                >
                  <social.icon className="w-4 h-4" strokeWidth={1.8} />
                </a>
              ))}
            </div>
          </div>

          {COLUMNS.map((col) => (
            <div key={col.title} className="md:col-span-2">
              <p className="text-xs font-semibold tracking-[0.2em] uppercase text-slate-500 mb-5">{col.title}</p>
              <ul className="space-y-3">
                {col.links.map((link) => (
                  <li key={link}>
                    <a
                      href={HREF_MAP[link] || "#"}
                      data-testid={`footer-link-${link.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                      className="text-sm text-slate-400 transition-colors duration-200 hover:text-white"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-white/10 mt-14 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-500" data-testid="footer-copyright">
            © 2026 Alignexa AI. All Rights Reserved.
          </p>
          <div className="flex gap-6">
            <a href="#" data-testid="footer-privacy-link" className="text-xs text-slate-500 hover:text-white transition-colors duration-200">
              Privacy Policy
            </a>
            <a href="#" data-testid="footer-terms-link" className="text-xs text-slate-500 hover:text-white transition-colors duration-200">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

function LandingLogoLight() {
  return (
    <span data-testid="footer-logo" className="flex items-center gap-2.5">
      <span className="w-9 h-9 rounded-xl bg-gradient-to-br from-[#2563EB] to-[#6366F1] flex items-center justify-center shadow-[0_8px_20px_rgba(37,99,235,0.4)]">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
        </svg>
      </span>
      <span className="font-display font-semibold text-lg tracking-tight text-white">
        Alignexa
        <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#60A5FA] to-[#818CF8]"> AI</span>
      </span>
    </span>
  );
}
